module.exports = __webpack_public_path__ + "img/icon-scene-1.23f3ce55.png";